// extracted by mini-css-extract-plugin
module.exports = {"typeSummaryCard":"LessonTypeSummaryCard_typeSummaryCard__ifEZO","header":"LessonTypeSummaryCard_header__c_Mp6"};